function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { ExternalLink } from '@shared/components/externalLink';
import SpzaComponent from '@shared/components/spzaComponent';
export class BannerLinks extends SpzaComponent {
    renderImpl() {
        var _this_props_links;
        if (!((_this_props_links = this.props.links) === null || _this_props_links === void 0 ? void 0 : _this_props_links.length)) {
            return;
        }
        return this.props.links.map(({ text, url, params })=>{
            const bannerTitle = params ? this.context.locParams(text, params) : this.context.loc(text);
            const telemetryDetails = JSON.stringify({
                bannerTitle,
                bannerTargetUrl: url
            });
            return /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(ExternalLink, {
                    onClickHandle: this.onLinkClick,
                    rel: "noreferrer",
                    target: "_blank",
                    className: "c-hyperlink",
                    href: url,
                    accessibilityEnabled: true,
                    telemetryDetails: telemetryDetails,
                    children: bannerTitle
                })
            }, `banner-link-${bannerTitle}-${url}`);
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0), _define_property(this, "onLinkClick", (event)=>{
            var _this_props_onLinkClick, _this_props;
            (_this_props_onLinkClick = (_this_props = this.props).onLinkClick) === null || _this_props_onLinkClick === void 0 ? void 0 : _this_props_onLinkClick.call(_this_props, {
                event
            });
        });
    }
}
BannerLinks.contextTypes = {
    loc: PropTypes.func,
    locDateString: PropTypes.func,
    locParams: PropTypes.func
};
